import { $ } from "./lib/$.module";
import { modal } from "./lib/modal.module";

{
    function onClick(e) {
		const target = e.target.closest('a[modal]');
        if (target) {
			e.cancelBubble = true;
            e.preventDefault();
            e.stopPropagation();
            modal($(target.dataset.modalHrefSelector));
        }
    }

    document.addEventListener('click', onClick)
}